import axios from "axios";
import axiosAuth from "./interceptor";

export const getAppHomeData = async (regionId, customerId) => {
  if (regionId) {
    const response = await axios.get(
      `getAppHomeData/${regionId}/${customerId}`,
    );
    return response.data;
  } else {
    return { data: null };
  }
};
export const sortProducts = async (slug, user, filterValue) => {
  const response = await axios.get(
    `sortProducts/${slug}/${user?.region_id}/${user?.customer_id}/${
      filterValue?.sortType
    }/${JSON.stringify(filterValue?.flavour)}/${JSON.stringify(
      filterValue?.weight,
    )}`,
  );
  return response.data;
};
export const customerCart = async (customer_id, region_id) => {
  const response = await axios.get(`customerCart/${customer_id}/${region_id}`);
  return response.data;
};
export const getAddressListWithDeliveryCharge = async (
  customer_id,
  region_id,
) => {
  const response = await axios.get(
    `getAddressListWithDeliveryCharge/${customer_id}/${region_id}`,
  );
  return response.data?.data;
};
export const listAllAddress = async (customer_id) => {
  const response = await axios.get(`listAllAddress/${customer_id}`);
  return response.data?.data;
};
export const getAddressDetails = async (addressId) => {
  const response = await axios.get(`getAddressDetails/${addressId}`);
  return response.data?.data;
};
export const getAddonsListByRegion = async (region_id) => {
  const response = await axios.get(`getAddonsListByRegion/${region_id}`);
  return response.data;
};
// export const getActivePromo = async () => {
//   const response = await axios.get(`getActivePromo`);
//   return response.data;
// };
export const getActivePromo = async (customer_id) => {
  const response = await axios.get(`getActivePromo`, {
    params: {
      // ✅ Use params, not data
      customer_id: customer_id,
    },
  });
  return response.data;
};
export const shopListByRegion = async (user) => {
  const response = await axios.get(
    `getAllShopDetailsByRegionId/${user?.region_id}`,
  );
  return response.data;
};
export const getCustomerDetails = async (user) => {
  const response = await axios.get(`getCustomerDetails/${user?.customer_id}`);
  return response.data?.data;
};
export const listCustomerOrders = async (user) => {
  const response = await axios.get(`listCustomerOrders/${user?.customer_id}`);
  return response.data?.data;
};

export const getOrderDetails = async (orderId) => {
  const response = await axios.get(`getOrderDetails/${orderId}`);
  return response.data?.data;
};

export const getProductDetails = async (productId, customerId, regionId) => {
  const response = await axios.get(
    `getProductDetailsForId/${productId}/${customerId}/${regionId}`,
  );
  return response.data;
};

export const seachPlaceholder = async () => {
  const response = await axios.get(`search-placeholder`);
  return response.data?.data;
};

export const getProductsForUniversalSearch = async (regionId) => {
  const response = await axios.get(`getProductsForUniversalSearch/${regionId}`);
  return response.data;
};
export const getPaymentDetails = async (regionId, setUser) => {
  if (regionId) {
    const response = await axios.get(`getPaymentDetails/${regionId}`);
    let encryptedKey = response.data.data;
    setUser((prev) => ({ ...prev, PAYMENT_KEY: encryptedKey }));
    return response.data;
  }
};

export const addToCart = async (formData) => {
  const response = await axiosAuth.post(`addToCart`, formData);
  return response.data;
};
export const addComboToCart = async (formData) => {
  const response = await axiosAuth.post(`addComboToCart`, formData);
  return response.data;
};
export const storeFullAddress = async (params) => {
  const response = await axiosAuth.post(`storeFullAddress`, params);
  return response.data;
};
export const editFullAddress = async (params) => {
  const response = await axiosAuth.post(`editFullAddress`, params);
  return response.data;
};
export const editCustomerDetails = async (params) => {
  const response = await axiosAuth.post(`editCustomerDetails`, params);
  return response.data;
};

export const sendToLaravelServer = async (params) => {
  const response = await axios.post(`verifyOTP`, params);
  return response.data;
};

export const updateCartQuantity = async (param) => {
  const response = await axios.get(
    `updateQuantityCart/${param?.cartId}/${param?.qty}/${param?.customerId}`,
  );
  return response.data;
};
export const updateComboCartQuantity = async (param) => {
  const response = await axios.get(
    `updateComboQuantityCart/${param?.parentId}/${param?.qty}/${param?.customerId}`,
  );
  return response.data;
};
export const updateAddonQuantity = async (param) => {
  console.log(param);
  const response = await axios.get(
    `updateAddonQuantity/${param?.customerId}/${param?.cartId}/${param?.qty}`,
  );
  return response.data;
};
export const updateCartMessage = async (param) => {
  const response = await axios.get(
    `updateMessageOnCakeCart/${param?.cartId}/${param?.message}`,
  );
  return response.data;
};
export const updatePrimaryAddress = async (param) => {
  const response = await axios.get(
    `updatePrimaryAddress/${param?.customerId}/${param?.addressId}`,
  );
  return response.data;
};
export const getPrimaryAddress = async (customerId) => {
  const response = await axios.get(`getPrimaryAddress/${customerId}`);
  return response.data;
};
export const deleteAddress = async (addressId) => {
  const response = await axios.get(`deleteAddress/${addressId}`);
  return response.data;
};
export const getDeliveryFeeData = async (customerId, regionId) => {
  const response = await axios.get(
    // `getTestDeliveryCharge/${customerId}/${regionId}`
    `getDeliveryCharge/${customerId}/${regionId}`,
  );
  return response.data?.data;
};
export const getAvailableSlots = async (preparation, date) => {
  const response = await axios.get(`getAvailableSlots/${preparation}/${date}`);
  return response.data?.data;
};

// export const checkPromo = async (promo_code) => {
//   const response = await axios.get(`checkPromo/${promo_code}`);
//   return response.data;
// };
export const checkPromo = async (promo_code, customer_id = null) => {
  const url = customer_id
    ? `checkPromo/${promo_code}?customer_id=${customer_id}`
    : `checkPromo/${promo_code}`;

  const response = await axios.get(url);
  return response.data;
};

export const getAllActiveRegionList = async () => {
  const response = await axios.get(`getAllActiveRegionList`);
  return response.data;
};

export const storeAddonsToCart = async (params) => {
  const response = await axiosAuth.post(`storeAddonsToCart`, params);
  return response.data;
};

export const getRelatedProducts = async (customerId, productId) => {
  const response = await axios.get(
    `relatedProducts/${customerId}/${productId}`,
  );
  return response.data;
};
export const getAllActiveShopDetailsByRegion = async (regionId) => {
  const response = await axios.get(`getAllShopDetailsByRegionId/${regionId}`);
  return response.data;
};

export const getAllDetailsByRegion = async () => {
  const response = await axios.get(`getAllShopDetails`);
  return response.data;
};

export const getPincodeCheck = async (pincode) => {
  const response = await axios.get(`getPincodeDetails/${pincode}`);
  return response.data;
};
export const updateBulkCartQuantity = async (param) => {
  const response = await axios.get(
    `updateBulkQuantityCart/${param?.cartId}/${param?.qty}/${param?.customerId}/${param?.weightId}`
  );
  return response.data;
};

export const shareProduct = async (productName) => {
  const response = await axios.get(`products/${productName}/share`);
  return response.data;
};